// Typelizer digest a01915c704945ae6080311f31b168509
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /account/confirmation/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/account/confirmation/new', {}, options),
    method: 'get',
  }),

  /** GET /account/confirmation */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/account/confirmation', {}, options),
    method: 'get',
  }),

  /** POST /account/confirmation */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/account/confirmation', {}, options),
    method: 'post',
  }),

  /** POST /account/confirmation/confirm */
  confirm: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/account/confirmation/confirm', {}, options),
    method: 'post',
  }),
}
